// Generated by CoffeeScript 2.7.0
var CommentSetting;

import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';

import Options from 'trunks/vue/share/components/options.js';

export default CommentSetting = {
  components: {
    dropdown: DropdownSelect,
    Options: Options
  },
  props: {
    initialCommentStatus: {
      type: String
    },
    // private options
    commentOptions: {
      type: Array,
      default: function() {
        return ['comment_must_approved', 'comment_auto_approved', 'comment_closed'];
      }
    }
  },
  data: function() {
    return {
      formatedCommentOptions: this._generateCommentOptions(),
      commentStatusOption: null,
      commentEnabled: false
    };
  },
  template: `<div class="comment-setting">
  <div class="tab-section">
    <h4 class="tab-section-title">用户评论:</h4>
    <div class="tab-section-content">
      <div class="options">
        <label class="option-item">
          <input type="checkbox" hidden='true' :checked="commentEnabled" v-model="commentEnabled"/>
          <i class="slp-square-o"></i>
          <span class="option-label">
            <span>开启评论</span>
          </span>
        </label>
      </div>
      <Options optionsClass="comment-status-options"
               v-if="commentEnabled"
               :initialSelectedOptions="[commentStatusOption]"
               :options="commentStatusOptionsForSelect"
               :multiple="false"
               @valueChange="onOptionValueChangeFunc"
               ref="optionRef">
      </Options>
    </div>
  </div>
</div>`,
  created: function() {
    var init_comment_status_option;
    init_comment_status_option = _.find(this.formatedCommentOptions, (option) => {
      return option.id === this.initialCommentStatus;
    });
    this.commentStatusOption = init_comment_status_option || this.defaultEnableCommentStatusOption;
    return this.commentEnabled = this.commentStatusOption !== this.commentClosedStatusOption;
  },
  computed: {
    commentClosedStatusOption: function() {
      return _.last(this.formatedCommentOptions);
    },
    commentStatusOptionsForSelect: function() {
      return _.without(this.formatedCommentOptions, this.commentClosedStatusOption);
    },
    defaultEnableCommentStatusOption: function() {
      return _.first(this.formatedCommentOptions);
    }
  },
  watch: {
    commentEnabled: function(enable_comment) {
      return this.commentStatusOption = enable_comment ? this.defaultEnableCommentStatusOption : this.commentClosedStatusOption;
    }
  },
  methods: {
    getData: function() {
      return {
        comment_status: this.commentStatusOption.id
      };
    },
    onOptionValueChangeFunc: function(options) {
      var option;
      option = _.first(options);
      if (option) {
        return this.changeCommentStatusOption(option);
      } else {
        return this.$refs.optionRef.valueChangeFunc(this.commentStatusOption, true);
      }
    },
    changeCommentStatusOption: function(option) {
      return this.commentStatusOption = option;
    },
    _generateCommentOptions: function() {
      return _.map(this.commentOptions, function(option_id) {
        return new Skylark.App.Model.FieldOption({
          id: option_id,
          value: Skylark.Helpers.translate("comment.status." + option_id)
        });
      });
    }
  }
};
